export const pkg = {
  name: 'isomorphic-git',
  version: '1.30.1',
  agent: 'git/isomorphic-git@1.30.1',
}
